/*
  Collection and search listings (sections hj-collection, hj-search). The live Hydrogen app swaps the grid in place;
  here the same happens through the Section Rendering API (?section_id=<id>), keeping the URL params Shopify reads:
  filter.p.product_type, filter.p.tag, sort_by, page.
  - Filter chips, "x" chips, Back, header crumbs with data-hj-nav, Clear Filters: fetch the target URL's section,
    replace the header (.hj-ch), toolbar (.hj-pfb) and grid ([data-hj-grid]), push the URL.
  - Sort select: same, with sort_by (featured = the collection's own order, no sort_by).
  - Load more: fetch the next page's section, append its cards, move the button on, URL unchanged (as live).
  - The toolbar sticks under the sticky site header (live sets its top to the header height).
  - Collection copy "Read more" / "Read less".
  Without JS the Load more link and the add-to-cart forms still work (plain page 2, /cart/add).
*/
(function () {
  'use strict';
  if (window.HJListing) return;
  var SORTS = { featured: '', newest: 'created-descending', 'price-low': 'price-ascending', 'price-high': 'price-descending' };

  function root() { return document.querySelector('[data-hj-listing]'); }
  function sectionUrl(url, id) {
    var u = new URL(url, window.location.href);
    u.searchParams.set('section_id', id);
    return u.toString();
  }
  function fetchSection(url) {
    var r = root();
    if (!r) return Promise.reject(new Error('no listing'));
    return fetch(sectionUrl(url, r.getAttribute('data-section-id')), { credentials: 'same-origin', headers: { accept: 'text/html' } })
      .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  function header() {
    return document.querySelector('header[data-sb-chrome="header"]') || document.querySelector('header');
  }
  function stick() {
    var bar = document.querySelector('[data-hj-listing] .hj-pfb');
    if (!bar) return;
    var h = header();
    var top = 0;
    if (h) {
      var pos = window.getComputedStyle(h).position;
      if (pos === 'sticky' || pos === 'fixed') top = Math.round(h.getBoundingClientRect().height);
    }
    bar.style.top = top + 'px';
  }

  var busy = false;
  function swap(doc) {
    ['.hj-ch', '.hj-pfb', '[data-hj-grid]'].forEach(function (sel) {
      var cur = document.querySelector('[data-hj-listing] ' + sel);
      var next = doc.querySelector(sel);
      if (cur && next) cur.replaceWith(document.importNode(next, true));
      else if (cur && !next) cur.remove();
    });
    stick();
  }
  function navigate(url, push) {
    if (busy) return;
    busy = true;
    fetchSection(url).then(function (doc) {
      swap(doc);
      if (push) window.history.pushState({ hjListing: true }, '', url);
      busy = false;
    }).catch(function () { busy = false; window.location.assign(url); });
  }

  function loadMore(a) {
    if (a.hasAttribute('data-hj-pending')) return;
    a.setAttribute('data-hj-pending', '');
    fetchSection(a.href).then(function (doc) {
      var grid = document.querySelector('[data-hj-listing] [data-hj-grid] .sc-grid-c4');
      var nextGrid = doc.querySelector('[data-hj-grid] .sc-grid-c4');
      var added = 0;
      if (grid && nextGrid) {
        Array.prototype.slice.call(nextGrid.children).forEach(function (card) {
          grid.appendChild(document.importNode(card, true));
          added++;
        });
      }
      var wrap = document.querySelector('[data-hj-listing] [data-hj-more-wrap]');
      var nextWrap = doc.querySelector('[data-hj-more-wrap]');
      if (wrap) wrap.innerHTML = nextWrap ? nextWrap.innerHTML : '';
      var status = document.querySelector('[data-hj-listing] [data-hj-status]');
      if (status) status.textContent = added + ' more product' + (added === 1 ? '' : 's') + ' loaded';
    }).catch(function () {
      window.location.assign(a.href);
    }).then(function () { a.removeAttribute('data-hj-pending'); });
  }

  document.addEventListener('click', function (e) {
    var r = root();
    if (!r || !r.contains(e.target)) return;
    var more = e.target.closest('a[data-hj-more]');
    if (more) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      loadMore(more);
      return;
    }
    var nav = e.target.closest('button[data-url], a[data-hj-nav]');
    if (nav) {
      if (nav.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0)) return;
      e.preventDefault();
      var url = nav.getAttribute('data-url') || nav.getAttribute('href');
      if (url) navigate(url, true);
      return;
    }
    var readMore = e.target.closest('.sc-cc-more');
    if (readMore) {
      var clip = document.getElementById(readMore.getAttribute('aria-controls'));
      if (!clip) return;
      var open = readMore.getAttribute('aria-expanded') === 'true';
      if (open) {
        clip.classList.add('is-collapsed');
        clip.style.maxHeight = '320px';
        readMore.setAttribute('aria-expanded', 'false');
        readMore.textContent = 'Read more';
      } else {
        clip.classList.remove('is-collapsed');
        clip.style.maxHeight = '';
        readMore.setAttribute('aria-expanded', 'true');
        readMore.textContent = 'Read less';
      }
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-hj-listing] .hj-pfb-sort');
    if (!sel) return;
    var u = new URL(window.location.href);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    var v = SORTS[sel.value];
    if (v) u.searchParams.set('sort_by', v); else u.searchParams.delete('sort_by');
    navigate(u.pathname + u.search, true);
  });

  window.addEventListener('popstate', function (e) {
    if (!root()) return;
    if (e.state && e.state.hjListing) navigate(window.location.href, false);
  });

  function init() {
    if (!root()) return;
    try { window.history.replaceState({ hjListing: true }, '', window.location.href); } catch (err) {}
    stick();
    window.addEventListener('resize', stick);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.HJListing = { navigate: navigate, stick: stick };
})();
